export default {
    layout: {
        loading: '交易进行中',
        trading: '交易进行中'
    },
    footer: {
    },
    menu: {
        home: '首页',
        staking: '矩阵',
        port: 'PORT',
        internet: '网络',
        me: '我的',
    },
    header: {
        selectLang: '选择语言',
        close: '关闭',
        trading: '交易',
        dashboard: '仪表盘',
        subscribeMatrix: '认购矩阵',
        portTaskCenter: 'PORT任务中心',
        network: '网络',
        apiBinding: 'API绑定',
        gridTree: '网格树',
        account: '账户',
        documents: '文档与白皮书',
        personalCenter: '个人中心',
        language: '语言'
    },
    home: {
        recently1:'社区',
        staticrewares: '静态',
        recentlyName: '账本',
        recentlyInfo: '收益明细',
        dataUpdate: '数据更新',
        realtime: '实时·BSC',
        totalRevenue: '总收益 (USDT)',
        today: '今日',
        totalTradingVolume: '总交易额',
        todayEarn: '今日获取',
        share: '分享给朋友',
        shareDesc: '晒出收益邀请赚奖励',
        directReferrals: '直推人数',
        teamMembers: '团队人数',
        thisWeek: '本周',
        copy: 'Copy',
        recently: '最近收益',
        netIncome: '净收益',
        dailyAverage: '日均',
        quantitativeIncome: '量化',
        recommend: '推荐',
        port: 'PORT',
        bonus: '奖金',
        all: '全部',
        todayTitle: '今日',
        loadingMore: '加载更早',
        recommendBonus: '推荐奖励',
        portTaskPassed: 'PORT任务通过',
        myProfit: '我的盈亏',
        earningOnBitDeep: '我在BitDeep赚收益',
        totalRevenueUsdt: '总收益 · USDT',
        consecutiveDays: '连续天数',
        scanToJoin: '扫码加入',
        uid: 'UID',
        referralBonus: '推荐奖励',
        shareTo: '分享至',
        eachReferral: '分享奖励',
        screenshotAndShare: '截图并分享',
        saveShareEarn: '保存 · 转发 · 赚奖励',
        period: '周期',
        netProfit: '净收益',
        quantReward: '量化收益',
        dailyBonus: 'PORT每日奖励',
        close: '关闭',
        permission: '权限',
        onlyEnable: '仅开启',
        enterBitgetUid: '请输入BITGET UID',
        slogan: '口令',
        document: '文档',
        days: '天',
        taskText: '任务',
        minutes: '分钟',
        decentralizedPortTech: '去中心化PoRT的技术架构、BGB代币经济学，及双区激励矩阵。',
        auditReport: '审计报告',
        faqSupport: '常见问题&支持',
        telegram: 'Telegram',
        piece: '份',
        faq: '常见问题',
        faq1: '如何绑定 Bitget API？',
        faq1Desc: '进入 Bitget 交易所 → 设置 → API 管理，获取 API Key 和 Secret。权限只勾选现货交易，严禁勾选提现权限。将密钥粘贴至 BitDeep DApp，用户完成 1U 测试交易即激活。',
        faq2: '什么是 PoRT（真实交易证明）？',
        faq2Desc: 'PoRT 是"交易即挖矿"的核心机制。用户每日通过 Bitget API 自动执行指定币种（如 BGB）的速买速卖，完成流水 > 质押金 × 50% 的门槛，系统验证后触发当日收益。',
        faq3: '每天需要手动盯盘吗？',
        faq3Desc: '不需要。API 绑定后，系统在 24 小时窗口内自动完成交易任务，无需手动操作；用户可通过 PoRT 菜单进行检查。',
        faq4: 'ALPHA 和 SIGMA 有什么区别？',
        faq4Desc: 'ALPHA（初级）：500 U 质押，每日收益 0.3–1.3%，只能购买 1 套。SIGMA（专业）：1,000 U 质押，每日收益 0.6–1.6%，最多购买 5 套。',
        faq5: '我的资金安全吗？平台能动我的钱吗？',
        faq5Desc: '资金 100% 留存在你自己的 Bitget 账户。API 仅授权现货读取与交易，系统无法提现或转移任何本金。',
        faq6: '每日收益什么时候结算？',
        faq6Desc: 'PoRT 验证通过后，隔日结算，系统自动释放 USDT 收益与 10x Deep 积分双重奖励。',
        faq7: '伯乐奖（直推奖励）怎么计算？',
        faq7Desc: '每直推一位有效账户，每天获得固定奖励：推荐 ALPHA（500 U）账户得 1 USDT/天，推荐 SIGMA（1,000 U）账户得 2 USDT/天，持续到该账户周期结束。',
        faq8: '级别（D1–D7）怎么升级？',
        faq8Desc: '根据小区总业绩达标升级。例如：D1 需 2,000 U 业绩，D3 需 15,000 U，D7 最高需 300 万 U 业绩。级别越高，级差奖励越丰厚（D7 最高 7 U/人/天）。',
        faq9: '一个周期是多少天？到期后怎么处理？',
        faq9Desc: '一个周期为 28 天。周期结束后可选择继续质押，收益按实际每日 PoRT 验证结果浮动发放。',
        faq10: '提现有手续费吗？',
        faq10Desc: '提现 0 手续费。平台将提现费用反哺底池，用于 LP 增厚，形成良性循环。',
        bigArea: '大区',
        smallArea: '小区',
        enterWithdrawAmount: '输入提币数量',
        all: '全部',
        available: '可用',
        totalAmount: '总金额',
        confirmWithdraw: '确认提现',
        withdrawRecord: '提现记录',
        withdrawn: '已转出',
        quickStartGuide:'快速开始',
        whitepaperGuide:'白皮书&指南',
        whitepaper:'白皮书',
        downloadPdf:'下载'
    },
    staking: {
        selectPackage: '认购矩阵',
        alpha: 'ALPHA',
        beginner: '入门',
        sigma: 'SIGMA',
        professional: '专业',
        popular: '最受欢迎',
        dailyReturn: '任务收益',
        teamDepth: '团队深度',
        limitPurchase: '限购',
        layer: '层',
        copy: '份',
        autoRenew: '到期自动续期',
        autoReinvest: '自动续约保证金',
        subscribeAlpha: '认购Alpha',
        subscribeSigma: '认购Sigma',
        stakedAmount: '保证金',
        stakedAmount2: '周期',
        stakedAmount3: '累计收益',
        stakingTime: '参与时间',
        maturityTime: '到期时间',
        redeem: '赎回',
        renew: '续期',
        autoRenewActive: '已自动续费',
        autoRenewInactive: '未自动续费',
        smartContract: '智能合约托管，保证金在28天周期内锁定，到期解锁。',
        alter2:'有到期质押，请续期',
    },
    me: {
        account: '账户',
        my: '我的',
        staked: '已参与',
        staked1:'保证金',
        points: '积分',
        consecutive: '连续天数',
        withdraw: '提现',
        language: '语言',
        simplifiedChinese: '简体中文',
        disconnectWallet: '断开钱包',
        level: '等级',
        joinDate: '加入时间',
        bdId: 'BD-ID'
    },
    bindapi: {
        apiBinding: 'API绑定',
        bindDesc: '绑定您的交易所API密钥以授权量化交易',
        apiKey: 'API Key',
        apiSecret: 'API Secret',
        exchange: '交易所',
        futures: '合约',
        spot: '现货',
        readOnly: '仅只读',
        bind: '绑定',
        riskNote: 'API密钥仅用于交易数据同步，不存储敏感信息',
        apiConnection: 'API 连接',
        bindExchangeApi: '绑定交易所API',
        bitDeepRead: 'BitDeep读取您 CEX账户的订单流以验证真实交易证明(PoRT)。',
        noWithdraw: '我们绝不接触您的提现。',
        securityTip: '安全提示·请仔细阅读',
        close: '关闭',
        withdraw: '提现',
        permission: '权限',
        onlyEnable: '仅开启',
        spotTrading: '现货交易',
        read: '读取',
        recommendedPartner: '推荐合作伙伴',
        zeroFee: '0% 手续费',
        activated: '已激活',
        classicAccount: '经典账户',
        unifiedAccount: '统一账户',
        bindBitgetApi: '绑定 Bitget API',
        upcoming: '即将推出',
        underAudit: '集成审计中',
        expected: '预计'
    },
    port: {
        portTaskCenter: 'PORT任务中心',
        dailyTask: '每日任务',
        verify: '验证',
        completed: '已完成',
        incomplete: '未完成',
        verifyStandard: '验证标准',
        tradingVolume: '交易额',
        today: '今日',
        deadline: '截止时间',
        reward: '奖励',
        startVerify: '开始验证',
        verifying: '验证中',
        verified: '已验证',
        insufficient: '未达标',
        viewDetails: '查看详情',
        taskList: '任务列表',
        allTasks: '全部任务',
        completedTasks: '已完成',
        pendingTasks: '待完成',
        proofOfRealTrading: '真实交易证明',
        todayTask: '今日任务',
        todayStaticIncome: '今日任务收益',
        points: '积分',
        todayWindowClosesAt: '今日窗口截止于',
        checkTaskStatus: '检查任务状态',
        teamProgress: '团队进度·今日',
        realtimePortCompletion: '实时 PORT 完成情况',
        completedText: '已完成',
        pendingText: '待完成',
        realtimeApiValidationFlow: '实时 · API · 验证流',
        rewardRemark1:'全球分红',
        rewardRemark2:'级差奖',
        rewardRemark3:'伯乐奖',
        rewardRemark4:'任务奖励',
        rewardRemark5:'PoRT 任务通过',
    },
    internet: {
        network: '网络',
        treeBrowser: '树状浏览器',
        searchAddress: '搜索 0x...地址或 BD-ID',
        totalTradingVolume: '总交易额',
        members: '位成员',
        networkStructure: '网络结构',
        allLevels: '全部等级',
        addRemark: '添加备注',
        enterRemark: '请输入备注',
        cancel: '取消',
        confirm: '确认',
        alert1:'直推业绩',
        alert2:'团队业绩',
        alert3:'任务状态',
    },
    withdraw: {
        withdraw: '提现',
        usdtAsset: 'USDT资产',
        withdrawAmount: '提现金额',
        availableBalance: '可用余额',
        fee: '手续费',
        actualArrival: '实际到账',
        submit: '提交',
        withdrawSuccess: '成功',
        withdrawFailed: '失败',
        processing: '处理中',
        completed: '已完成',
        withdrawHistory: '提现记录',

    },
    popup: {
        taskUnfinished: '任务未完成',
        taskUnfinishedDesc: '交易数据未达到今日PoRT验证标准',
        todayTradingVolume: '今日交易额',
        remaining: '尚需',
        toComplete: '即可完成今日任务',
        tradingVolumeThreshold: '',
        deadline: '距任务截止还有',
        tryAgain: '稍后再试',
        goTrade: '去交易',
        taskCompleted: '任务验证通过',
        taskCompletedDesc: '今日PoRT交易证明已成功上链',
        rewardIssued: '奖励发放',
        complete: '完成',
        shareTitle: '分享邀请',
        shareDesc: '邀请好友注册，双方均可获得奖励',
        referralLink: '邀请链接',
        qrCode: '二维码',
        copyLink: '复制链接',
        notask:'今日无任务',
        notaskDesc:'当前没有待处理的PoRT交易任务',
    }
};
